import requestFunctions from "../../functions/requestFunctions";


export const state = {
  PLANNED_ITEM: {},
  PLANNED_LIST: [],
  PLANNED_TABLE_DATA: [],
  PLANNED_ARRAY_DATA: [],
  PLANNED_TOTAL_ROWS: 0
}

export const getters = {
  GET_PLANNED_ITEM: (state) => {
    return state.PLANNED_ITEM;
  },
  GET_PLANNED_LIST: (state) => {
    return state.PLANNED_LIST;
  },
  GET_PLANNED_TABLE_DATA: (state) => {
    return state.PLANNED_TABLE_DATA;
  },
  GET_PLANNED_ARRAY_DATA: (state) => {
    return state.PLANNED_ARRAY_DATA;
  },
  GET_PLANNED_TOTAL_ROWS: (state) => {
    return state.PLANNED_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_PLANNED_ITEM(state, item) {
    state.PLANNED_ITEM = item;
  },

  UPDATE_PLANNED_LIST(state, list) {
    
    state.PLANNED_LIST = list.data;

    state.PLANNED_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.PLANNED_TABLE_DATA = [];
    state.PLANNED_ARRAY_DATA = [];

    list.forEach(el => {

      state.PLANNED_TABLE_DATA.push({
        'uuid'   : el.uuid,
        'id'     : el.id,
        'period' : el.period,
        'name'   : el.name,
        'marketplace_name' : el.marketplace_name,
        'shop_name'    : el.shop_name,
        'company_name' : el.company_name,
        'created_at'   : el.created_at,
        'updated_at'   : el.updated_at,
      });

      state.PLANNED_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        period: el.period,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_PLANNED_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/planned/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PLANNED_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_PLANNED_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/planned';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PLANNED_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_PLANNED_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/planned';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_PLANNED_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/planned/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_PLANNED_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/planned/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}